var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useOkapiKy, useCallout } from "@folio/stripes/core";
import { Pane, Button, MessageBanner, ErrorModal, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchProductById, updateProductAccessibility, } from "../../api/productService";
import ProductDetail from "./ProductDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { ProductAccessibilityEnum } from "../../types/Api";
import { ProductAccessibilityConfirmModal } from "../../components/ProductAccessibilityConfirmModal";
import { ProductActionButtons } from "../../components/ProductActionButtons";
import { ProductPublishingDateRequiredModal } from "../../components/ProductPublishingDateRequiredModal";
import { RecordPreviewModal } from "../../components/RecordPreviewModal";
import { BarcodeGeneratorModal } from "../../components/product/BarcodeGeneratorModal";
import { usePermissions } from "../../hooks/usePermissions";
import { useCanAssignProductNumber } from "../../hooks/useCanAssignProductNumber";
import { useCoEditionNumberRequest } from "../../hooks/useCoEditionNumberRequest";
import { CoEditionRequestModal } from "../../components/product/CoEditionRequestModal";
import { CoEditionAssignModal } from "../../components/product/CoEditionAssignModal";
import { CoEditionConsentBanner } from "../../components/product/CoEditionConsentBanner";
import { CoEditionDeclinedBanner } from "../../components/product/CoEditionDeclinedBanner";
import { useMakePublicGuard } from "../../hooks/product/useMakePublicGuard";
import { useModal } from "../../utils/useModal";
import { useProductDelete } from "../../hooks/product/useProductDelete";
import { ProductDeleteModals } from "../../components/product/ProductDeleteModals";
import { isForbiddenError, retryUnlessForbidden } from "../../utils/httpErrors";
var PRODUCT_LIST_PATH = "/bragency/products";
var ProductDetailPage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var id = useParams().id;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var queryClient = useQueryClient();
    var callout = useCallout();
    var _l = useModal(), errorOpen = _l.isOpen, errorMessage = _l.message, openError = _l.openModal, closeError = _l.closeModal;
    var _m = React.useState(false), isAccessibilityModalOpen = _m[0], setIsAccessibilityModalOpen = _m[1];
    var _o = React.useState(null), pendingAccessibility = _o[0], setPendingAccessibility = _o[1];
    var _p = usePermissions(), isAgencyWorker = _p.isAgencyWorker, isSuperUser = _p.isSuperUser, canDeleteProductItem = _p.canDeleteProductItem, canPreviewProduct = _p.canPreviewProduct;
    // The backend treats a superuser like an agency worker for co-edition requests.
    var isAgency = isAgencyWorker || isSuperUser;
    var publishGuard = useMakePublicGuard();
    var _q = React.useState(false), isCoEditionRequestModalOpen = _q[0], setIsCoEditionRequestModalOpen = _q[1];
    var _r = React.useState(false), isCoEditionAssignModalOpen = _r[0], setIsCoEditionAssignModalOpen = _r[1];
    var _s = React.useState(false), isPreviewOpen = _s[0], setIsPreviewOpen = _s[1];
    var _t = React.useState(false), isBarcodeOpen = _t[0], setIsBarcodeOpen = _t[1];
    var _u = useQuery(["product", id], function () { return fetchProductById(ky, id); }, {
        enabled: !!id,
        retry: retryUnlessForbidden,
    }), product = _u.data, isLoading = _u.isLoading, isError = _u.isError, error = _u.error, refetch = _u.refetch;
    var _v = useCanAssignProductNumber(product), canAssignProductNumber = _v.canAssignProductNumber, productNumbersData = _v.productNumbersData;
    var productNumbers = (_a = productNumbersData === null || productNumbersData === void 0 ? void 0 : productNumbersData.items) !== null && _a !== void 0 ? _a : [];
    var canDelete = !!productNumbersData &&
        canDeleteProductItem(product, productNumbers.length > 0);
    var productDelete = useProductDelete({
        // Explicit list route (not history.goBack): opened from a direct link or a
        // new tab, going back would leave the module.
        onDeleted: function () { return history.push(PRODUCT_LIST_PATH); },
    });
    var _w = useCoEditionNumberRequest(product), canRequestCoEditionNumber = _w.canRequest, pendingCoEditionRequest = _w.pendingRequest, awaitingCoEditionRequest = _w.awaitingRequest, declinedCoEditionRequest = _w.declinedRequest, isCurrentUserCoPublisher = _w.isCurrentUserCoPublisher, isCurrentUserTitleOwner = _w.isCurrentUserTitleOwner, coPublisherRow = _w.coPublisherRow, invalidateCoEditionQueries = _w.invalidate;
    var accessibilityMutation = useMutation(function (accessibility) {
        return updateProductAccessibility(ky, id, accessibility);
    }, {
        onSuccess: function () {
            queryClient.invalidateQueries(["product", id]);
            queryClient.invalidateQueries(["products"]);
            setIsAccessibilityModalOpen(false);
            setPendingAccessibility(null);
            refetch();
        },
    });
    var handleBackToList = function () {
        history.goBack();
    };
    var handleEdit = function () {
        history.push("/bragency/products/edit/".concat(id));
    };
    var handleMakePublic = function () {
        if (!product)
            return;
        publishGuard.requestMakePublic(product, function () {
            setPendingAccessibility(ProductAccessibilityEnum.PUBLIC);
            setIsAccessibilityModalOpen(true);
        });
    };
    var handleMakePrivate = function () {
        setPendingAccessibility(ProductAccessibilityEnum.PRIVATE);
        setIsAccessibilityModalOpen(true);
    };
    var confirmAccessibilityChange = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (pendingAccessibility) {
                accessibilityMutation.mutate(pendingAccessibility);
            }
            return [2 /*return*/];
        });
    }); };
    var cancelAccessibilityChange = function () {
        setIsAccessibilityModalOpen(false);
        setPendingAccessibility(null);
    };
    if (!id) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.product.detail.pane.title",
                }) },
                React.createElement("p", null, formatMessage({ id: "ui-br-agency.product.id.not.provided" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    if (isLoading) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.product.detail.pane.title",
                }) },
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))));
    }
    if (isError || !product) {
        return (React.createElement(RecekPaneSet, null,
            React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.product.detail.pane.title",
                }) },
                React.createElement("p", null, isForbiddenError(error)
                    ? formatMessage({ id: "ui-br-agency.error.access.denied" })
                    : (error === null || error === void 0 ? void 0 : error.message) ||
                        formatMessage({ id: "ui-br-agency.product.not.found" })),
                React.createElement(Button, { buttonStyle: "primary", onClick: handleBackToList },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })))));
    }
    var handleAddProductNumber = function () {
        history.push("/bragency/product-numbers/assign/".concat(id));
    };
    // The barcode generator is offered only for products whose ONIX form code
    // exists and does not start with "E" (i.e. hidden for the digital forms
    // EA/EB/EC/ED and for a missing form).
    var formCode = (_c = (_b = product.form) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.trim().toUpperCase();
    var canGenerateBarcode = !!formCode && !formCode.startsWith("E");
    var actionMenu = function () { return (React.createElement(ProductActionButtons, { product: product, onEdit: handleEdit, onMakePublic: handleMakePublic, onMakePrivate: handleMakePrivate, onAddProductNumber: canAssignProductNumber ? handleAddProductNumber : undefined, onRequestCoEditionNumber: canRequestCoEditionNumber
            ? function () { return setIsCoEditionRequestModalOpen(true); }
            : undefined, onPreview: canPreviewProduct(product) ? function () { return setIsPreviewOpen(true); } : undefined, onGenerateBarcode: canGenerateBarcode ? function () { return setIsBarcodeOpen(true); } : undefined, onDelete: canDelete
            ? function () { return productDelete.openDeleteConfirm(product, productNumbers); }
            : undefined })); };
    var productName = ((_f = (_e = (_d = product === null || product === void 0 ? void 0 : product.title) === null || _d === void 0 ? void 0 : _d.names) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.name) || (product === null || product === void 0 ? void 0 : product.id) || "";
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.product.detail.pane.title",
            }), firstMenu: React.createElement(Button, { buttonStyle: "default", onClick: handleBackToList, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" })), actionMenu: actionMenu },
            awaitingCoEditionRequest && (React.createElement(CoEditionConsentBanner, { request: awaitingCoEditionRequest, ownerName: (_h = (_g = product.title) === null || _g === void 0 ? void 0 : _g.owner) === null || _h === void 0 ? void 0 : _h.name, coPublisherName: (_j = awaitingCoEditionRequest.coPublisher) === null || _j === void 0 ? void 0 : _j.name, isCurrentUserCoPublisher: isCurrentUserCoPublisher, isAgency: isAgency, onChanged: function (messageId) {
                    invalidateCoEditionQueries();
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "success",
                        message: formatMessage({ id: messageId }),
                    });
                }, onError: function (message) {
                    invalidateCoEditionQueries();
                    openError(message);
                } })),
            declinedCoEditionRequest && (isAgency || isCurrentUserTitleOwner) && (React.createElement(CoEditionDeclinedBanner, { request: declinedCoEditionRequest })),
            pendingCoEditionRequest && (React.createElement(MessageBanner, { type: isAgency ? "warning" : "default" }, isAgency ? (React.createElement(React.Fragment, null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.pending.banner" }),
                " ",
                React.createElement(Button, { buttonStyle: "primary", marginBottom0: true, onClick: function () { return setIsCoEditionAssignModalOpen(true); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.pending.process" })))) : (React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.pending.info" })))),
            React.createElement(ProductDetail, { product: product })),
        isCoEditionRequestModalOpen && (React.createElement(CoEditionRequestModal, { productId: id, coPublisherName: ((_k = coPublisherRow === null || coPublisherRow === void 0 ? void 0 : coPublisherRow.publisher) === null || _k === void 0 ? void 0 : _k.name) || (coPublisherRow === null || coPublisherRow === void 0 ? void 0 : coPublisherRow.publisherName), onClose: function () { return setIsCoEditionRequestModalOpen(false); }, onCreated: function () {
                invalidateCoEditionQueries();
                setIsCoEditionRequestModalOpen(false);
            }, onError: function (message) {
                setIsCoEditionRequestModalOpen(false);
                openError(message);
            } })),
        isCoEditionAssignModalOpen && (pendingCoEditionRequest === null || pendingCoEditionRequest === void 0 ? void 0 : pendingCoEditionRequest.id) && (React.createElement(CoEditionAssignModal, { requestId: pendingCoEditionRequest.id, note: pendingCoEditionRequest.note, onClose: function () { return setIsCoEditionAssignModalOpen(false); }, onDone: function (outcome) {
                invalidateCoEditionQueries();
                setIsCoEditionAssignModalOpen(false);
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "success",
                    message: outcome.action === "assigned"
                        ? formatMessage({
                            id: outcome.numberLabel
                                ? "ui-br-agency.co-edition.assign.success.assigned"
                                : "ui-br-agency.title.products.panel.assign.assigned",
                        }, { value: outcome.numberLabel })
                        : formatMessage({
                            id: "ui-br-agency.co-edition.assign.success.rejected",
                        }),
                });
            }, onError: function (message) {
                setIsCoEditionAssignModalOpen(false);
                openError(message);
            } })),
        React.createElement(ErrorModal, { open: errorOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: errorMessage, onClose: closeError }),
        React.createElement(ProductAccessibilityConfirmModal, { open: isAccessibilityModalOpen, productName: productName, pendingAccessibility: pendingAccessibility, onConfirm: confirmAccessibilityChange, onCancel: cancelAccessibilityChange }),
        React.createElement(ProductPublishingDateRequiredModal, { open: publishGuard.isGuardOpen, onEdit: publishGuard.goToEdit, onCancel: publishGuard.closeGuard }),
        React.createElement(ProductDeleteModals, { state: productDelete }),
        React.createElement(RecordPreviewModal, { open: isPreviewOpen, target: { kind: "product", id: id }, onClose: function () { return setIsPreviewOpen(false); } }),
        React.createElement(BarcodeGeneratorModal, { open: isBarcodeOpen, productId: id, onClose: function () { return setIsBarcodeOpen(false); } })));
};
export default ProductDetailPage;
